import React from "react";
import { MainBanner } from "../../blocks/main-banner";
import { MainTwoThings } from "../../blocks/main-two-things";
// import { MainAdvance } from "../../blocks/main-advance";
import { MainIamSolutions } from "../../blocks/main-iam-solutions";
import { MainIndustrySolutions } from "../../blocks/main-industry-solutions";
import { MainCode } from "../../blocks/main-code";
import { MainNews } from "../../blocks/main-news";
import { MainComment } from "../../blocks/main-comment";
import { MainOthers } from "../../blocks/main-others";
import { Header } from "../../components/Header";
import { MainLogo } from "../../blocks/main-logo";
import "./styles.less";

export const MainPage = () => {
  return (
    <div className="main-page">
      <Header mode="dark" />
      <MainBanner />
      <MainLogo />
      <MainTwoThings />
      {/* <MainAdvance /> */}
      <MainIamSolutions />
      <MainIndustrySolutions />
      <MainCode />
      <MainNews />
      <MainComment />
      <MainOthers />
    </div>
  );
};
